var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tool-tip',{attrs:{"text":_vm.text,"content-class":"top","custom-class":"question","position":{ top: 'top' }}},[_c('svg-sprite',{attrs:{"icon-id":"CircleQuestion","width":"20","height":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }